<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-消息通知-修改
    -->
    <el-dialog
    title="修改消息通知"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="70%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      
     <!--  <el-form-item label="类型" >

          <div v-if="form.code == 'text'">内容</div>
          <div v-if="form.code == 'image'">图片</div>
        </el-form-item>
  -->

      <el-form-item label="消息通知标题" prop="context" v-if="form.code == 'text'">
        {{ form.context }}
      </el-form-item>
      <el-form-item label="消息通知内容" prop="remark" v-if="form.code == 'text'">
        {{ form.remark }}
      </el-form-item>
      <el-form-item label="开始时间" prop="start_time" v-if="form.code == 'text'">
        {{ form.start_time }}
      </el-form-item>
   
 <!--
      <el-form-item label="消息通知图片：" prop="model.image" v-if="form.code == 'image'">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.image">
          <transition-group>
            <div v-for="(item, index) in form.image" :key="item.file_path">
              <div class="item">
                <img v-img-url="item.file_path" alt="file_path"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'album')"><i class="el-icon-close"></i></a>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload('album')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>
 -->

    <el-form-item label="类型">
      <div style="display: flex; align-items: center; gap: 10px">
        <!-- 主选择器 -->
        <el-radio-group v-model="form.type">
          <el-radio :label="7">系统消息</el-radio>
          <el-radio :label="2">重要通知</el-radio>
          <el-radio :label="3">商家信息</el-radio>
          <el-radio :label="0">其它</el-radio>
        </el-radio-group>
      </div>
    </el-form-item>
    <el-form-item label="分类">
      <div style="display: flex; align-items: center; gap: 10px">
        <!-- 主选择器 -->
        <el-radio-group v-model="form.class_status">
          <el-radio :label="1">缴费提醒</el-radio>
          <el-radio :label="2">报修进度</el-radio>
          <el-radio :label="3">评价回复</el-radio>
          <el-radio :label="0">其它</el-radio>
        </el-radio-group>
      </div>
    </el-form-item>

    <el-form-item label="发送对象">
      <div style="display: flex; align-items: center; gap: 10px">
    <!-- 主选择器 -->
    <el-radio-group v-model="form.send_type">
      <el-radio :label="1">全站会员</el-radio>
      <el-radio :label="3">指定会员</el-radio>
    </el-radio-group>
  </div>
        </el-form-item>

        <!-- <el-form-item label="选择会员等级" v-if="form.send_type == 2">
          <el-select v-model="form.user_level" placeholder="请选择">
            <el-option v-for="(item, index) in grade" :key="index" :label="item.name" :value="item.grade_id"></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item label="会员" v-if="form.send_type == 3">
          <div class="d-s-s d-c">

            <ul class="d-s-s select-user">
              <li class="mr10 d-c-c d-c p-10-0" v-for="(item,index) in form.select_list" :key="index">
                  <img :src="item.avatarUrl" class="radius" width="30" height="30" />
                  <p class="lh18 ww100 text-ellipsis">{{item.nickName}}</p>
              </li>
            </ul>
          </div>
        </el-form-item>


        
        <el-form-item label="发送方式">
          <el-radio v-model="form.stype" :label="1">系统通知</el-radio>
        </el-form-item>




    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!-- <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片 -->
    <!-- </Upload> -->
    <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
  
    <!--选择用户-->
    <GetUser :is_open="open_getuser" @close="closeGetuserFunc"></GetUser>
  </div>
</el-dialog>
  
</template>

<script>
import MsgApi from '@/api/msg.js';

import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
import GetUser from '@/components/user/GetUser.vue';
export default {
  components: {
         /*图片上传*/
         Upload: Upload,
     Categoryas,
     draggable,
     Uediter,
     GetUser
  },
  data() {
    return {
          /*是否上传图片*/
          // isupload: false,
      isImg: false,  
          /*富文本配置*/
          ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        context:"",
        code: 'text',
        image:"",
        user_ids:[],
        send_type:1,
        stype:1,
        type:0,
        class_status:0,
        start_time:'',
        remark:''
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入消息通知名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
         code:"album"
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    this.getDetail();
  },
  props: ["open_add","msg_id"],
  methods: {
    // closeDialogFunc(e) {
    //   console.log(e)
    //   let self = this;
    //   self.iscategorya = false;
    //   if (e.type === 'success') {
    //     let arr = [];
    //     for (let i = 0; i < e.params.length; i++) {
    //       let item = e.params[i];
    //       arr = {
    //         name: item.name,
    //         categorya_id: item.categorya_id,
    //         image: item.image,
    //       };
    //     }
    //     self.form.categorya = arr;
    
    //   }
    // },
    chooseCategory(){
      this.iscategorya = true;
    },
     /*上传*/
    //  openUpload(e) {
    //   this.isupload = true;
    // },

     /*获取图片*/
     returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
          this.form.image = e[0].file_path;
          this.isImg = true;
        
      }
      this.isupload = false;
    },
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      MsgApi.detail({msg_id: self.msg_id},true).then(res => {
          self.form = res.data;
          self.ueditor.text = self.form.intro;
          self.isImg = true
          self.loading = false;
          if(!self.form.bannar){
            self.form.bannar = [];
          }
          if(!self.form.image){
            self.form.image = [];
          }
        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      let form = self.form;
      // if(!form.categorya.categorya_id){
      //   self.$message({
      //           message:"请选择全分类",
      //           type: 'error'
      //         });
      //         return;
      // }
      // if(form.image.length <=0){
      //   self.$message({
      //           message:"请上传图片",
      //           type: 'error'
      //         });
      //         return;
      // }
      form.msg_id = self.msg_id;
      // form.intro = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          MsgApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

  
    /*上传商品图片*/
    // returnProductImgsFunc(e) {
    //   if(this.code == 'album'){
    //     if (e != null) {
    //     let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
    //     let prevent = false;
    //     console.log(typeof imgExpt);
    //     e.forEach((element) => {
    //       let data_array = element.file_path.split(".");
    //       let ext = data_array[data_array.length - 1];
    //       imgExpt.forEach((e) => {
    //         if (e === ext) {
    //           prevent = true
    //           return false
    //         }
    //       });
    //     });

    //     if (!prevent) {
    //       this.$message.error("图片类型有误,请选择正确的图片格式");
    //       return false;
    //     }

    //     let imgs = this.form.image.concat(e);
    //     this.$set(this.form, "image", imgs);
    //   }
    //   }else{
    //     if (e != null) {
    //     let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
    //     let prevent = false;
    //     console.log(typeof imgExpt);
    //     e.forEach((element) => {
    //       let data_array = element.file_path.split(".");
    //       let ext = data_array[data_array.length - 1];
    //       imgExpt.forEach((e) => {
    //         if (e === ext) {
    //           prevent = true
    //           return false
    //         }
    //       });
    //     });

    //     if (!prevent) {
    //       this.$message.error("图片类型有误,请选择正确的图片格式");
    //       return false;
    //     }

    //     let imgs = this.form.bannar.concat(e);
    //     this.$set(this.form, "bannar", imgs);
    //   }
    //   }
      
    //   this.isProductUpload = false;
    // },

    /*删除商品图片*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}



.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/msg/index/part/edit.vue